import * as types from './mutation_types';

export default {
    [types.SET_INVENTORY_VENDORS](state, vendors) {
        state.inventoryVendors = vendors;
    },
};
